export type CampaignComparableModel = {
  address: string,
  auction_date: string,
  bathrooms: string,
  bedrooms: string,
  building_area: string,
  cache_key: number,
  campaign_id: number,
  carparks: string,
  comparable_source: string,
  country_code: string,
  data: any,
  data_provider: string,
  default_image?: string,
  distance: string,
  id: number,
  image_url: string,
  land_area?: string,
  latitude: string,
  listing_agency: string,
  listing_agent: string,
  longitude: string,
  post_code: string,
  price: string,
  price_guide: string,
  property_type: string,
  rpd: string,
  rental?: string,
  sale_method: string,
  sale_type: string,
  sold: boolean,
  sold_date: string,
  source_campaign_id?: number,
  state_name: string,
  street_name: string,
  street_number: string,
  suburb_name: string,
  unit_number: string,
}

export type CampaignComparableRequestOptions = {
  include_campaign_comparable_image?: boolean,
}

const state = {
  bathrooms: '',
  bedrooms: '',
  campaign_id: undefined,
  carparks: '',
  comparable_source: 'agency',
  data: {},
  external_link: '',
  image_id: undefined,
  land_area: '',
  notes: '',
  post_code: '',
  price_guide: '',
  property_type: '',
  sold: false,
  sold_date: '',
  state_name: '',
  street_name: '',
  street_number: '',
  suburb_name: '',
  unit_number: '',
}

export const requiredFields = [
  { key: 'bathrooms' },
  { key: 'bedrooms' },
  { key: 'carparks' },
  { key: 'post_code' },
  { key: 'price_guide' },
  { key: 'property_type' },
  { key: 'state_name' },
  { key: 'street_name' },
  { key: 'street_number' },
  { key: 'suburb_name' },
]

export default state
